<template>
  <form class="form" @submit.prevent="">
    <div class="form-fields">
      <div class="grid grid-cols-2 gap-6">
        <VFormInput
          label="First name*"
          placeholder="Enter first name"
          :initialValue="initialValues.first_name"
          :error="errors.first_name"
          @update="value => $emit('set', 'first_name', value)"
        />
        <VFormInput
          label="Enter last name*"
          placeholder="Enter last name"
          :initialValue="initialValues.last_name"
          :error="errors.last_name"
          @update="value => $emit('set', 'last_name', value)"
        />
      </div>

      <div class="grid grid-cols-2 gap-6">
        <VFormInput
          label="Email*"
          placeholder="Enter email address"
          inputType="email"
          :initialValue="initialValues.email"
          :error="errors.email"
          @update="value => $emit('set', 'email', value)"
        />
        <VFormInput
          label="Phone number*"
          placeholder="Enter phone number"
          :onlyDigits="true"
          :initialValue="initialValues.phone"
          :error="errors.phone"
          :formatValue="formatPhoneNumOnChange"
          @update="value => $emit('set', 'phone', value)"
        />
      </div>

      <div class="grid grid-cols-2 gap-6">
        <VFormSelect
          label="Customer / Business name*"
          placeholder="Find by customer's email, name..."
          :options="customers"
          optionKey="company_name"
          :initialSelectedOption="initialValues.customer"
          :error="errors.customer"
          :showFilterInput="true"
          :classes="{ options: 'max-h-74' }"
          @onSelect="value => $emit('set', 'customer', value)"
          @filter="text => $emit('filter', text)"
        />
        <VFormInput
          label="Contact's Password"
          placeholder="Enter contact's password"
          inputType="password"
          :error="errors.password"
          :initialValue="initialValues.password"
          @update="value => $emit('set', 'password', value)"
        />
      </div>

      <div v-if="editable" class="grid grid-cols-2 gap-6">
        <VFormInput
          label="Contact's Internal ID*"
          placeholder="Enter Internal ID"
          :onlyDigits="true"
          :initialValue="initialValues.internal_id"
          :error="errors.internal_id"
          @update="value => $emit('set', 'internal_id', value)"
        />
      </div>
    </div>
  </form>
</template>

<script>
import VFormInput from '@/components/base/VFormInput';
import VFormSelect from '@/components/base/VFormSelect';

import { formatPhoneNumOnChange } from '@/utils';

export default {
  name: 'ContactForm',
  components: { VFormInput, VFormSelect },
  props: {
    errors: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    initialValues: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    customers: {
      type: Array,
      required: false,
      default: () => [],
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    formatPhoneNumOnChange: phone => formatPhoneNumOnChange(phone),
  },
};
</script>
